// client/src/components/configuracoes/entrega/SecaoTeste.js
import React from 'react';
import { Navigation, Loader2, CheckCircle2, XCircle } from 'lucide-react';
import { useTenantI18n } from '../../../hooks/useAccounts';
import { formatCurrency, getCurrencySymbol } from '../../../utils/formatters';

// ============================================================
// SEÇÃO TESTAR CÁLCULO
// ============================================================
export const SecaoTeste = ({ testeForm, setTesteForm, testeResultado, testando, onTestar }) => {
    // ✅ ACHADO: rótulo/valores abaixo eram fixos em BRL/"(R$)", sem ler
    // configuracoesGerais.i18n da conta.
    const { currency, locale } = useTenantI18n();

    return (
        <div className="form-section">
            <h4 className="form-section-title">
                <Navigation size={15} style={{ marginRight: 5, verticalAlign: 'middle' }} />
                Simular Cálculo de Frete
            </h4>
            <div className="form-grid-container-cols-2">
                <div className="form-group">
                    <label className="form-label">CEP de Destino</label>
                    <input className="form-input" type="text" placeholder="00000-000" maxLength={9}
                        value={testeForm.cep}
                        onChange={e => setTesteForm(p => ({ ...p, cep: e.target.value }))} />
                </div>
                <div className="form-group">
                    <label className="form-label">Subtotal do Pedido ({getCurrencySymbol(currency, locale)})</label>
                    <input className="form-input" type="number" min="0" step="0.01" placeholder="0,00"
                        value={testeForm.subtotal}
                        onChange={e => setTesteForm(p => ({ ...p, subtotal: e.target.value }))} />
                </div>
                <div className="form-group">
                    <label className="form-label">Latitude do destino (opcional)</label>
                    <input className="form-input" type="number" step="any" placeholder="-23.5505"
                        value={testeForm.latitude}
                        onChange={e => setTesteForm(p => ({ ...p, latitude: e.target.value }))} />
                </div>
                <div className="form-group">
                    <label className="form-label">Longitude do destino (opcional)</label>
                    <input className="form-input" type="number" step="any" placeholder="-46.6333"
                        value={testeForm.longitude}
                        onChange={e => setTesteForm(p => ({ ...p, longitude: e.target.value }))} />
                </div>
            </div>
            <div style={{ marginTop: '0.5rem' }}>
                <button type="button" className="action-button action-button-secondary" onClick={onTestar} disabled={testando}>
                    {testando
                        ? <><Loader2 size={18} className="icon animate-spin" /> Calculando...</>
                        : <><Navigation size={18} className="icon" /> Calcular Frete</>
                    }
                </button>
            </div>

            {testeResultado && <ResultadoCalculo resultado={testeResultado} />}
        </div>
    );
};

// ============================================================
// RESULTADO DO CÁLCULO
// ============================================================
const ResultadoCalculo = ({ resultado }) => {
    // ✅ ACHADO: fixo em BRL, sem ler configuracoesGerais.i18n da conta.
    const { currency, locale } = useTenantI18n();
    const fmt = (v) => formatCurrency(v || 0, currency, locale);

    return (
        <div style={{ marginTop: '1.25rem', border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
            <div style={{ background: '#f8fafc', padding: '0.625rem 1rem', borderBottom: '1px solid #e5e7eb', display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: '0.875rem' }}>
                    {resultado.entregaDisponivel   ? <CheckCircle2 size={15} color="#16a34a" /> : <XCircle size={15} color="#dc2626" />}
                    Entrega {resultado.entregaDisponivel   ? 'disponível' : 'indisponível'}
                </span>
                <span style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: '0.875rem' }}>
                    {resultado.retiradaDisponivel  ? <CheckCircle2 size={15} color="#16a34a" /> : <XCircle size={15} color="#dc2626" />}
                    Retirada {resultado.retiradaDisponivel ? 'disponível' : 'indisponível'}
                </span>
            </div>

            {Array.isArray(resultado.opcoes) && resultado.opcoes.length > 0 ? (
                <table className="styled-table" style={{ margin: 0 }}>
                    <thead>
                        <tr>
                            <th>Tipo</th>
                            <th>Label</th>
                            <th>Valor</th>
                            <th>Prazo (h)</th>
                            <th>Frete Grátis</th>
                            <th>Status</th>
                            <th>Motivo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {resultado.opcoes.map((op, i) => (
                            <tr key={i}>
                                <td style={{ textTransform: 'capitalize' }}>{op.tipo}</td>
                                <td>{op.label || '—'}</td>
                                <td>{fmt(op.valor)}</td>
                                <td>{op.prazoHoras ?? op.prazoMinimoHoras ?? '—'}</td>
                                <td>{op.freteGratis ? 'Sim' : 'Não'}</td>
                                <td>
                                    {op.indisponivel
                                        ? <XCircle size={15} color="#dc2626" />
                                        : <CheckCircle2 size={15} color="#16a34a" />
                                    }
                                </td>
                                <td style={{ fontSize: '0.8rem', color: '#64748b' }}>{op.motivoIndisponivel || '—'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <div style={{ padding: '1rem', textAlign: 'center', color: '#64748b', fontSize: '0.875rem' }}>
                    Nenhuma opção retornada para os dados informados.
                </div>
            )}
        </div>
    );
};

export default SecaoTeste;
